import type { ReactNode } from "react"
import type { ControllerRenderProps, FieldPath, FieldValues, UseFormReturn } from "react-hook-form"

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form"

export type FieldProps = {
  form: UseFormReturn<FieldValues>
  name: string
  label?: string
  description?: string
  render: (field: ControllerRenderProps<FieldValues, string>) => ReactNode
}

export const Field = ({ form, name, label, description, render }: FieldProps) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem id={`field-${name}`} data-field={name}>
          {label ? <FormLabel>{label}</FormLabel> : null}
          {description ? <FormDescription>{description}</FormDescription> : null}
          <FormControl>{render(field)}</FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
